import React, {useContext, useEffect} from 'react';
import propTypes from 'prop-types';
import Context from '../OriginStoryProvider';

const DeepDiveParagraph = ({paragraph, elClass, chapterNum, section, deepDiveImages}) => {
	const { data: {content} } = useContext(Context);

	const handleHover = function(event) {
		const cta = document.getElementById('deep-dive__cta');
		const ctaText = document.getElementById('deep-dive__cta__text')
	
		if (event.type === 'mouseenter') {
			cta.classList.add('visible');
			const rect = this.getBoundingClientRect();
			const TOP_GAP = 2;
			const leftPos = rect.left + window.scrollX + this.offsetWidth;
			const isOffScreen = leftPos + this.offsetWidth > window.innerWidth;
			cta.style.left = isOffScreen ? `${window.innerWidth - this.offsetWidth}px` : `${leftPos}px`;
			cta.style.top = `${rect.bottom + window.scrollY + TOP_GAP}px`;
			ctaText.textContent = content.chapters[chapterNum][section][this.dataset.slug]?.title;
		}
	
		if (event.type === 'mouseleave') {
			cta.classList.remove('visible');
			cta.style.left = 'initial';
			cta.style.top = 'initial';
			ctaText.textContent = '';
		}
	}

	const formattedImages = (images) => {
		return images.map(image => {
			return `<li class="deep-dive__modal__img"><img src="${image.img_src}" alt="${image.img_alt}" loading="lazy"></li>`
		});
	};
	
	const handleClick = function(event) {
		event.preventDefault();
		const deepDiveModal = document.getElementById('deep-dive__modal');
		const deepDiveModalTitle = document.getElementById('deep-dive__modal__title');
		const deepDiveModalText = document.getElementById('deep-dive__modal__text');
		const deepDiveImgContainer = document.getElementById('deep-dive__modal__img-container');
		document.body.classList.add('js-lock-body');
		deepDiveModal.showModal();
		deepDiveModalTitle.textContent = content.chapters[chapterNum][section][this.dataset.slug]?.title;
		deepDiveModalText.innerHTML = content.chapters[chapterNum][section][this.dataset.slug]?.paragraph;
		const images = deepDiveImages[this.dataset.slug]?.images;
		
		if (images && images.length > 0) {
			const innerContent = `
			<ul class="${elClass}__deep-dive__modal__img-list deep-dive__modal__img-list">
				${formattedImages(images).join(' ')}
			</ul>
			<p class="deep-dive__modal__img-caption img-caption">${content.chapters[chapterNum][section][this.dataset.slug]?.img_caption}</p>
			`
			deepDiveImgContainer.innerHTML = innerContent;
		} else {
			deepDiveImgContainer.innerHTML = '';
		}
	}
	
	const handleKeypress = function(event) {
		event.preventDefault();
		event.stopPropagation();
		const modalIsVisible = document.getElementById('deep-dive__modal').open;

		if (event.key === 'Enter') {
			if (!modalIsVisible) {
				handleClick.call(event.target, event);
			}
		}
	}
	
	useEffect(() => {
		// the html content will be passed via API from the CMS so we're using dangerouslySetInnerHTML and handling the event listeners here
		const deepDiveLinks = document.querySelectorAll(`.${elClass} .deep-dive__link`);
			
		if (!deepDiveLinks) return;
	
		deepDiveLinks.forEach((deepDiveLink) => {
			deepDiveLink.addEventListener('mouseenter', handleHover);
			deepDiveLink.addEventListener('mouseleave', handleHover);
			deepDiveLink.addEventListener('click', handleClick);
			deepDiveLink.addEventListener('keydown', handleKeypress);
		})
	
		return () => {
			deepDiveLinks.forEach((deepDiveLink) => {
				deepDiveLink.removeEventListener('mouseenter', handleHover);
				deepDiveLink.removeEventListener('mouseleave', handleHover);
				deepDiveLink.removeEventListener('click', handleClick);
				deepDiveLink.removeEventListener('keydown', handleKeypress);
			})
		}
	
	}, [content.chapters]);
	
	const handleClose = function() {
		const deepDiveModal = document.getElementById('deep-dive__modal');
		deepDiveModal.close();
		document.body.classList.remove('js-lock-body');
	}

	const handleKeypressClose = function(event) {
		event.preventDefault();
		event.stopPropagation();
		const modalIsVisible = document.getElementById('deep-dive__modal').open;
		
		if (event.key === 'Enter') {
			if (modalIsVisible) {
				handleClose.call(event.target, event);
			}
		}
	}
	
	useEffect(() => {
		const deepDiveModalCloseBtn = document.getElementById('deep-dive__modal__close-btn');
	
		if (!deepDiveModalCloseBtn) return;
		deepDiveModalCloseBtn.addEventListener('click', handleClose);
		deepDiveModalCloseBtn.addEventListener('keydown', handleKeypressClose);
	
		return () => {
			deepDiveModalCloseBtn.removeEventListener('click', handleClose);
			deepDiveModalCloseBtn.removeEventListener('keydown', handleKeypressClose);
		}
	}, [content.chapters]);
	
	return 	<p className={`${elClass}__paragraph`} dangerouslySetInnerHTML={{__html: paragraph}}></p>
}

export default DeepDiveParagraph;

DeepDiveParagraph.propTypes = {
	paragraph: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired,
	chapterNum: propTypes.string.isRequired,
	section: propTypes.string.isRequired,
	deepDiveImages: propTypes.object
}